import React from 'react';
import NursingTestCatalogManager from '../nursing/NursingTestCatalogManager';

export default function HeadDoctorNursingTestsPage() {
  return <NursingTestCatalogManager />;
}
